// client/components/primitives/Button.tsx
// Button primitive with helpId support

import { Button as Base } from "../ui/button";
import { HelpTip } from "../../ui/help/HelpTip";
import { useHelpEditMode } from "../../state/HelpEditMode";
import { HintPencil } from "../HintPencil";
import type { HelpKey } from "../../ui/help/helptext.en-US";
import * as React from "react";

type Props = React.ComponentProps<typeof Base> & {
  helpId?: HelpKey;
  helpSide?: "top" | "right" | "bottom" | "left";
};

export function Button({ helpId, helpSide, children, ...rest }: Props) {
  const { enabled } = useHelpEditMode();

  const btn = <Base {...rest}>{children}</Base>;
  const wrapped = helpId ? <HelpTip helpId={helpId} side={helpSide}>{btn}</HelpTip> : btn;

  if (enabled && helpId) {
    return (
      <div className="relative inline-block">
        {wrapped}
        <HintPencil onClick={() => {
          window.dispatchEvent(new CustomEvent("open-help-editor", { detail: { helpId } }));
        }}/>
      </div>
    );
  }

  return wrapped;
}
